module.exports = __webpack_public_path__ + "static/img/Acceptance_bill_picture@2x.d047760.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/applicationDiscount/Acceptance_bill_picture@2x.png
// module id = SGE0
// module chunks = 70